/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { IconButton, Title } from '@cambridgeassessment/cambridge-ui';
import { Centre, CentreBase } from '@cambridgeassessment/lib-ee-commons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { StyledInputContainer } from '../Content.styles';
import { StyledRow, TextColumn } from './ConsortiaManagement.styles';
import { CancelOutlined } from '@cambridgeassessment/cambridge-ui/build/icons';
import { scienceBlue } from '@cambridgeassessment/cambridge-ui/build/abstracts/colours';
import CentreIdTextField from '../../../components/CentreIdTextField/CentreIdTextField';

interface Props {
  onCentresChange: (centres: CentreBase[]) => void;
  centres: CentreBase[];
}

const CentresSelection = ({ onCentresChange, centres }: Props): React.ReactElement => {
  const { consortium } = useSelector((state: RootState) => state.consortiaManagement);

  useEffect(() => {
    if (consortium?.centres) onCentresChange(consortium?.centres);
  }, [consortium?.centres]);

  const setSelectedCentre = (centre: Centre | null) => {
    if (centre) {
      onCentresChange([{ id: centre.id, name: centre.name }, ...centres]);
    }
  };

  const removeCentre = (id: string): void => {
    onCentresChange(centres.filter((centre) => centre.id !== id));
  };

  const validateCentreId = (centreId: string) => {
    const alreadyExists = centres.find((centre) => centre.id.toUpperCase() === centreId);
    if (alreadyExists) {
      return 'Centre is already added';
    }
  };

  return (
    <StyledInputContainer>
      <Title>Centres</Title>
      <CentreIdTextField
        dataQaId={'centres-select'}
        value={null}
        validateCentreId={validateCentreId}
        onChange={setSelectedCentre}
        helperText={'Consortium should include at least two centres.'}
      />
      {centres?.map((centre) => (
        <StyledRow key={`${centre.id}-${centre.name}`}>
          <TextColumn data-qa-id={`centre-${centre.id}`}>{`${centre.id} - ${centre.name}`}</TextColumn>
          <IconButton
            aria-label='remove centre'
            qaId={`remove-centre-${centre.id}`}
            onClick={() => removeCentre(centre.id)}
          >
            <CancelOutlined fill={scienceBlue} />
          </IconButton>
        </StyledRow>
      ))}
    </StyledInputContainer>
  );
};

export default CentresSelection;
